import React from 'react';
import { Badge } from 'react-bootstrap';

const UserPageHeader = ({ iconClass, title, subtitle, badgeLabel }) => (
  <div className="mb-6 sm:mb-8">
    <div className="bg-white/90 backdrop-blur-sm rounded-2xl sm:rounded-3xl px-5 py-4 sm:p-6 border border-purple-100 shadow-xl">
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
        <div className="flex items-center gap-4">
          <div className="w-12 h-12 sm:w-14 sm:h-14 bg-gradient-to-br from-purple-600 via-pink-600 to-red-600 rounded-xl sm:rounded-2xl flex items-center justify-center text-white text-xl sm:text-2xl shadow-md flex-shrink-0">
            <i className={iconClass} aria-hidden="true" />
          </div>
          <div>
            <h2 className="text-left text-2xl sm:text-2xl font-bold text-gray-900 mb-1">{title}</h2>
            {subtitle && (
              <p className="text-left text-gray-600 text-sm sm:text-base m-0">{subtitle}</p>
            )}
          </div>
        </div>
        {badgeLabel && (
          <Badge
            bsPrefix="custom-hamburger"
            className="text-white bg-gradient-to-br from-purple-600 via-pink-600 to-red-600 font-semibold rounded-lg sm:rounded-xl shadow-md transition-all duration-200 text-xs sm:text-sm flex items-center justify-center gap-2 p-2 px-3"
          >
            {badgeLabel}
          </Badge>
        )}
      </div>
    </div>
  </div>
);

export default UserPageHeader;
